import { useSelector } from 'react-redux';
import { getFlag } from 'state/Flags';
import { expectedFlags } from 'feature-flags';
import { Timesheet } from 'type';

/**
 * Hook to get the pay rate for a timesheet from the API response
 * The pay rate comes from /api/timesheets endpoint as pay_rate
 * Only returns a pay rate if the multiplePayRates feature flag is enabled
 */
export function useTimesheetPayRate(timesheet: Timesheet | null | undefined): string | null {
  // All hooks must be called unconditionally at the top
  const multiplePayRatesEnabled = useSelector(getFlag[expectedFlags.multiplePayRates]);
  
  // Early returns after all hooks have been called
  // Pay rate should only be displayed if the feature flag is enabled
  if (!multiplePayRatesEnabled) {
    return null;
  }

  if (!timesheet) {
    return null;
  }

  // Get pay rate directly from the timesheet's pay_rate property
  const payRate = timesheet.pay_rate;
  
  if (payRate != null && !isNaN(payRate)) {
    return `£${payRate.toFixed(2)} p/h`;
  }

  return null;
}

